export const ServicesAll = [
  //for making pull request
  {
    mainHeader: 'Why Choose KU Contractor for Cleaning',
    mainSubHeader:
      'At KU Contractors Limited, we deliver spotless results with precision, care, and reliability. Whether it’s residential, commercial, or post-construction cleaning — our team ensures every surface shines.',
    subservices: [
      {
        icon: '/deepclean.jpg',
        title: 'Deep Cleaning',
        desc: 'Thorough top-to-bottom cleaning for kitchens, bathrooms, and hard-to-reach areas.',
      },
      {
        icon: '/officecleaning.jpg',
        title: 'Office & Commercial Cleaning',
        desc: 'Keep your workplace hygienic and welcoming with routine or one-off cleanings.',
      },
      {
        icon: '/carpetclean.jpg',
        title: 'Carpet & Upholstery Cleaning',
        desc: 'Revive your carpets and furniture with professional stain and dirt removal.',
      },
      {
        icon: '/afterbuildclean.jpg',
        title: 'After-Build Cleaning',
        desc: 'Post-construction cleaning to make your newly built or renovated space move-in ready.',
      },
      {
        icon: '/windowclean.jpg',
        title: 'Window Cleaning',
        desc: 'Crystal-clear results for both interior and exterior glass surfaces.',
      },
      {
        icon: '/domesticclean.jpg',
        title: 'Domestic Cleaning',
        desc: 'Reliable household cleaning with trusted professionals who care for your home.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🧽',
        title: 'Attention to Detail',
        desc: 'We don’t miss a spot — precision and care in every corner.',
      },
      {
        icon: '🌿',
        title: 'Eco-Friendly Products',
        desc: 'Safe cleaning solutions for your family, pets, and environment.',
      },
      {
        icon: '🕒',
        title: 'Flexible Scheduling',
        desc: 'Cleaning services designed to fit your timetable, not ours.',
      },
    ],
    downHeader: 'Why Choose KU Contractor for Cleaning',
    downSubHeader:
      'At KU Contractors Limited, we deliver spotless results with precision, care, and reliability. Whether it’s residential, commercial, or post-construction cleaning — our team ensures every surface shines.',
  },
  {
    mainHeader: 'Home Extensions by KU Contractor',
    mainSubHeader:
      'Transform your living space with KU Contractors Limited. From single-storey additions to full-scale property extensions, our expert team ensures seamless integration, lasting quality, and a design that perfectly fits your lifestyle.',
    subservices: [
      {
        icon: '/singlestoreyextension.jpg',
        title: 'Single-Storey Extensions',
        desc: 'Add valuable space to your home with expertly built single-storey extensions.',
      },
      {
        icon: '/doublestoreyextension.png',
        title: 'Double-Storey Extensions',
        desc: 'Enhance both ground and upper floors while increasing property value.',
      },
      {
        icon: '/kitchenextension.jpg',
        title: 'Kitchen Extensions',
        desc: 'Create open-plan, modern kitchen spaces designed for comfort and functionality.',
      },
      {
        icon: '/loftconversion.jpg',
        title: 'Loft Conversions',
        desc: 'Turn unused attic areas into stylish bedrooms, offices, or playrooms.',
      },
      {
        icon: '/orangeriesconservatories.jpg',
        title: 'Orangeries & Conservatories',
        desc: 'Add light-filled spaces that blend indoor comfort with outdoor beauty.',
      },
      {
        icon: '/planningsupport.png',
        title: 'Planning & Design Support',
        desc: 'From concept drawings to permissions — we handle every stage with care.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🏠',
        title: 'Seamless Design Integration',
        desc: 'We ensure your new space blends perfectly with your existing home.',
      },
      {
        icon: '🧱',
        title: 'Quality Construction',
        desc: 'Built with precision, premium materials, and long-lasting structural integrity.',
      },
      {
        icon: '📋',
        title: 'End-to-End Project Handling',
        desc: 'From concept to completion — we manage every detail for you.',
      },
    ],
    downHeader: 'Why Choose KU Contractor for Home Extensions',
    downSubHeader:
      'We specialize in extending homes with precision, compliance, and craftsmanship. Whether it’s expanding your kitchen, adding a new bedroom, or reimagining your living space — we make it smooth, stress-free, and beautifully finished.',
  },
  {
    mainHeader: 'Gardening Services by KU Contractor',
    mainSubHeader:
      'At KU Contractors Limited, we transform outdoor spaces into vibrant, well-maintained gardens. From routine lawn care to complete landscape makeovers — our skilled gardening team brings life, balance, and beauty to every corner of your property.',
    subservices: [
      {
        icon: '/lawns.webp',
        title: 'Lawn Care & Maintenance',
        desc: 'Regular mowing, edging, and treatment to keep your lawn lush and healthy all year round.',
      },
      {
        icon: '/planting.webp',
        title: 'Planting & Flower Beds',
        desc: 'Seasonal planting and custom flower bed design to add colour and character to your garden.',
      },
      {
        icon: '/hedgetrimming.jpg',
        title: 'Hedge Trimming & Pruning',
        desc: 'Expert trimming and shaping for hedges, shrubs, and small trees to maintain a neat appearance.',
      },
      {
        icon: '/gardenmakeover.webp',
        title: 'Garden Makeovers',
        desc: 'Transform neglected spaces into stunning, functional gardens designed around your lifestyle.',
      },
      {
        icon: '/turfing.png',
        title: 'Turfing & Reseeding',
        desc: 'Professional turf installation and reseeding for patchy or worn lawns.',
      },
      {
        icon: '/gardenwaste.jpg',
        title: 'Garden Clearance & Waste Removal',
        desc: 'We clear debris, overgrowth, and unwanted materials to restore your garden’s natural beauty.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🌿',
        title: 'Experienced Garden Specialists',
        desc: 'Our team combines creativity and expertise to maintain and enhance your outdoor space.',
      },
      {
        icon: '🌼',
        title: 'Sustainable Practices',
        desc: 'We use eco-friendly methods and locally sourced plants for a greener, healthier garden.',
      },
      {
        icon: '🕒',
        title: 'Flexible Maintenance Plans',
        desc: 'Weekly, monthly, or one-off visits — tailored to your garden’s needs and your schedule.',
      },
    ],
    downHeader: 'Why Choose KU Contractor for Gardening',
    downSubHeader:
      'Whether it’s regular maintenance or a complete redesign, KU Contractor’s gardening services deliver professional care and creativity. We ensure your garden stays vibrant, well-kept, and welcoming throughout every season.',
  },
  {
    mainHeader: 'Painting & Decorating by KU Contractor',
    mainSubHeader:
      'Revitalize your property with KU Contractors Limited’s professional painting and decorating services. From interior makeovers to exterior finishes, our skilled team ensures precision, protection, and long-lasting results.',
    subservices: [
      {
        icon: '/interiorpainting.webp',
        title: 'Interior Painting',
        desc: 'Enhance your home’s interiors with smooth, flawless finishes and vibrant colours.',
      },
      {
        icon: '/exteriorpainting.jpg',
        title: 'Exterior Painting',
        desc: 'Protect and beautify your property’s exterior with weather-resistant, durable coatings.',
      },
      {
        icon: '/wallpapering.jpg',
        title: 'Wallpaper Installation & Removal',
        desc: 'Add character to your walls with expert wallpaper application and safe removal services.',
      },
      {
        icon: '/woodpainting.jpg',
        title: 'Woodwork & Metal Painting',
        desc: 'Detailed painting for doors, windows, railings, and trims to ensure a refined finish.',
      },
      {
        icon: '/touchup.jpg',
        title: 'Touch-Ups & Maintenance',
        desc: 'Keep your property looking fresh with quick, cost-effective paint repairs and updates.',
      },
      {
        icon: '/decorativefinishes.jpeg',
        title: 'Decorative Finishes',
        desc: 'Custom effects such as textured coatings, feature walls, and colour consultation.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🎨',
        title: 'Premium Quality Materials',
        desc: 'We use trusted brands and durable finishes to ensure long-lasting protection and beauty.',
      },
      {
        icon: '🪜',
        title: 'Skilled & Reliable Painters',
        desc: 'Our professionals deliver clean, precise work with minimal disruption.',
      },
      {
        icon: '🧾',
        title: 'Transparent Quotes',
        desc: 'No hidden costs — clear, fair pricing from start to finish.',
      },
    ],
    downHeader: 'Why Choose KU Contractor for Painting',
    downSubHeader:
      'We take pride in our craftsmanship and attention to detail. From preparation to final coat, KU Contractor guarantees a flawless finish that enhances and protects your property.',
  },
  {
    mainHeader: 'Roofing Services by KU Contractor',
    mainSubHeader:
      'Protect your property with KU Contractors Limited’s comprehensive roofing services. From minor repairs to full roof installations, we ensure durability, weather resistance, and professional finish every time.',
    subservices: [
      {
        icon: '/roofrepair.png',
        title: 'Roof Repairs',
        desc: 'Quick and efficient solutions for leaks, damage, and general wear and tear.',
      },
      {
        icon: '/newroofinstallation.jpg',
        title: 'New Roof Installation',
        desc: 'Expertly installed roofs using high-quality materials for lasting performance.',
      },
      {
        icon: '/flatroofing.jpg',
        title: 'Flat Roofing Systems',
        desc: 'Installation and repair of modern, efficient flat roof systems for homes and extensions.',
      },
      {
        icon: '/guttering.webp',
        title: 'Guttering & Fascias',
        desc: 'Complete guttering services including installation, cleaning, and maintenance.',
      },
      {
        icon: '/roofinspection.webp',
        title: 'Roof Inspections',
        desc: 'Detailed assessments to identify issues early and prevent costly future repairs.',
      },
      {
        icon: '/tilingandslates.png',
        title: 'Tiling & Slating',
        desc: 'Precision roof tiling and slating to match your home’s style and structure.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🔧',
        title: 'Certified Roof Specialists',
        desc: 'Trained professionals with extensive experience in residential and commercial roofing.',
      },
      {
        icon: '☔',
        title: 'Weatherproof & Reliable',
        desc: 'We use high-grade materials to ensure protection against harsh weather conditions.',
      },
      {
        icon: '🧱',
        title: 'Full Safety Compliance',
        desc: 'All work is performed to UK safety and building regulations standards.',
      },
    ],
    downHeader: 'Why Choose KU Contractor for Roofing',
    downSubHeader:
      'Your roof is your home’s first line of defence. KU Contractor ensures strength, safety, and style in every project — from small fixes to complete installations.',
  },
  {
    mainHeader: 'Plumbing Services by KU Contractor',
    mainSubHeader:
      'KU Contractors Limited offers reliable, efficient plumbing services for homes and businesses. From emergency leaks to full bathroom installations, our certified plumbers deliver prompt, professional results you can trust.',
    subservices: [
      {
        icon: '/leakrepair.jpeg',
        title: 'Leak Detection & Repairs',
        desc: 'Fast, accurate detection and repair of leaks to prevent water damage and waste.',
      },
      {
        icon: '/bathroominstallation.webp',
        title: 'Bathroom Installations',
        desc: 'Complete bathroom fitting including pipework, fixtures, and finishing touches.',
      },
      {
        icon: '/draincleaning.jpg',
        title: 'Drain Cleaning & Unblocking',
        desc: 'Efficient clearing of blockages to restore smooth water flow and hygiene.',
      },
      {
        icon: '/pipeinstallation.jpg',
        title: 'Pipe Installation & Replacement',
        desc: 'High-quality pipework solutions for new builds, renovations, or repairs.',
      },
      {
        icon: '/boilerservice.jpg',
        title: 'Boiler & Heating Services',
        desc: 'Installation, maintenance, and repair of domestic boiler and heating systems.',
      },
      {
        icon: '/emergencyplumbing.jpg',
        title: 'Emergency Plumbing',
        desc: '24/7 rapid response for leaks, bursts, and urgent plumbing problems.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🚰',
        title: 'Qualified & Experienced Plumbers',
        desc: 'Our team is trained, certified, and dedicated to delivering dependable solutions.',
      },
      {
        icon: '⏱️',
        title: 'Fast Response Times',
        desc: 'We respond quickly to minimize disruption and damage in emergency situations.',
      },
      {
        icon: '💧',
        title: 'Long-Lasting Solutions',
        desc: 'We focus on quality workmanship that ensures your plumbing performs for years.',
      },
    ],
    downHeader: 'Why Choose KU Contractor for Plumbing',
    downSubHeader:
      'From everyday maintenance to major installations, KU Contractor’s plumbing services combine expertise, efficiency, and care — keeping your water systems running smoothly and safely.',
  },
  {
    mainHeader: 'Carpets & Flooring by KU Contractor',
    mainSubHeader:
      'At KU Contractors Limited, we provide expert flooring and carpet installation that combines style, durability, and precision. Whether it’s hardwood, vinyl, laminate, or custom carpets — we ensure every floor is finished to perfection.',
    subservices: [
      {
        icon: '/carpetinstallation.jpg',
        title: 'Carpet Installation',
        desc: 'Expert fitting for all carpet types — ensuring smooth edges, tight seams, and perfect alignment.',
      },
      {
        icon: '/hardwoodfloor.jpg',
        title: 'Hardwood Flooring',
        desc: 'Elegant and long-lasting wooden floors, installed with precision and care.',
      },
      {
        icon: '/vinylflooring.jpg',
        title: 'Vinyl & Laminate Flooring',
        desc: 'Affordable, stylish, and durable flooring options for both homes and offices.',
      },
      {
        icon: '/tileflooring.webp',
        title: 'Tile & Stone Flooring',
        desc: 'Beautifully laid ceramic, porcelain, or natural stone tiles that elevate any interior.',
      },
      {
        icon: '/floorrepairs.jpg',
        title: 'Floor Repairs & Restoration',
        desc: 'We restore damaged floors to their original finish, saving you the cost of full replacement.',
      },
      {
        icon: '/underfloorheating.avif',
        title: 'Underfloor Heating Installation',
        desc: 'Add modern comfort with efficient underfloor heating solutions for new and existing spaces.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🪵',
        title: 'Premium Materials',
        desc: 'We source high-quality flooring materials that ensure durability and timeless appeal.',
      },
      {
        icon: '📏',
        title: 'Precision Installation',
        desc: 'Every cut, joint, and edge is crafted with expert attention to detail.',
      },
      {
        icon: '🏡',
        title: 'Custom Design Options',
        desc: 'Choose from a wide range of materials, patterns, and finishes tailored to your space.',
      },
    ],
    downHeader: 'Why Choose KU Contractor for Carpets & Flooring',
    downSubHeader:
      'We believe great flooring is the foundation of every beautiful space. From premium materials to expert installation, KU Contractors Limited delivers comfort, style, and craftsmanship that lasts.',
  },
  {
    mainHeader: 'Bathroom Fittings by KU Contractor',
    mainSubHeader:
      'At KU Contractors Limited, we specialize in complete bathroom fitting and renovation services. From plumbing and tiling to luxury fixtures and custom designs — we turn every bathroom into a space of comfort, style, and functionality.',
    subservices: [
      {
        icon: '/bathroominstallation.jpg',
        title: 'Full Bathroom Installation',
        desc: 'Complete installation services — from initial layout and plumbing to the final finishing touches.',
      },
      {
        icon: '/showerfitting.jpg',
        title: 'Shower & Bath Fitting',
        desc: 'Professional fitting of showers, bathtubs, and enclosures with leak-proof precision.',
      },
      {
        icon: '/toiletfitting.avif',
        title: 'Toilet & Sink Installation',
        desc: 'Expert installation of toilets, basins, and vanity units for all bathroom styles.',
      },
      {
        icon: '/bathroomtiling.jpg',
        title: 'Tiling & Waterproofing',
        desc: 'High-quality wall and floor tiling with full waterproof protection for long-lasting performance.',
      },
      {
        icon: '/bathroomlighting.jpg',
        title: 'Lighting & Electrical Work',
        desc: 'Safe and aesthetic bathroom lighting installations that enhance atmosphere and usability.',
      },
      {
        icon: '/bathroomrenovation.webp',
        title: 'Bathroom Renovation',
        desc: 'Transform old bathrooms into modern, elegant, and efficient spaces tailored to your preferences.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🚿',
        title: 'Complete Service',
        desc: 'From design to installation, we handle every aspect of your bathroom project.',
      },
      {
        icon: '🔧',
        title: 'Skilled Technicians',
        desc: 'Our experienced plumbers, tilers, and fitters deliver exceptional workmanship every time.',
      },
      {
        icon: '✨',
        title: 'Modern Finishes',
        desc: 'We bring your dream bathroom to life with stylish, functional, and durable fittings.',
      },
    ],
    downHeader: 'Why Choose KU Contractor for Bathroom Fittings',
    downSubHeader:
      'KU Contractors Limited offers end-to-end bathroom fitting solutions designed around your comfort and style. With our expertise, every bathroom becomes a refined and relaxing space built to last.',
  },
  {
    mainHeader: 'Tiling Services by KU Contractor',
    mainSubHeader:
      'KU Contractors Limited provides expert wall and floor tiling for residential and commercial projects. From ceramic and porcelain to marble and stone, we ensure seamless finishes with lasting quality.',
    subservices: [
      {
        icon: '/floortiling.jpg',
        title: 'Floor Tiling',
        desc: 'Durable and elegant tile installations for kitchens, bathrooms, and living areas.',
      },
      {
        icon: '/walltiling.jpeg',
        title: 'Wall Tiling',
        desc: 'Precise wall tile fitting for bathrooms, kitchens, and decorative interiors.',
      },
      {
        icon: '/mosaictiles.webp',
        title: 'Mosaic & Feature Walls',
        desc: 'Custom-designed mosaic layouts and patterned tiles that elevate your space.',
      },
      {
        icon: '/outdoortiling.png',
        title: 'Outdoor & Patio Tiling',
        desc: 'Weather-resistant tiles fitted for patios, pathways, and exterior walls.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🧩',
        title: 'Flawless Finishes',
        desc: 'We deliver perfectly aligned tiles with clean grout lines and durable sealing.',
      },
      {
        icon: '🧱',
        title: 'Premium Materials',
        desc: 'We use top-quality adhesives and tiles for a lasting, stylish finish.',
      },
      {
        icon: '🎨',
        title: 'Custom Design Options',
        desc: 'Choose from a wide range of designs, sizes, and materials for your project.',
      },
    ],
    downHeader: 'Why Choose KU Contractor for Tiling',
    downSubHeader:
      'Our tiling specialists bring precision, creativity, and craftsmanship to every surface — delivering flawless results that stand the test of time.',
  },
  {
    mainHeader: 'Ground Works by KU Contractor',
    mainSubHeader:
      'At KU Contractors Limited, our groundwork services lay the foundation for strong, stable, and lasting construction. From excavation to drainage and concrete foundations, we handle every stage with precision.',
    subservices: [
      {
        icon: '/excavation.webp',
        title: 'Excavation & Site Preparation',
        desc: 'Comprehensive site clearance, leveling, and excavation for all building projects.',
      },
      {
        icon: '/foundationwork.jpeg',
        title: 'Foundations & Concrete Works',
        desc: 'Strong, durable foundation laying to ensure your building stands solid.',
      },
      {
        icon: '/drainagesystem.webp',
        title: 'Drainage & Utility Installation',
        desc: 'Expert setup of water, gas, and waste systems with accurate groundwork.',
      },
      {
        icon: '/landscapingground.avif',
        title: 'Driveways & External Groundwork',
        desc: 'Durable driveways, patios, and external surfaces with professional finishing.',
      },
    ],
    whyChooseUs: [
      {
        icon: '⚒️',
        title: 'Experienced Team',
        desc: 'Our groundwork experts ensure solid and compliant foundations for every project.',
      },
      {
        icon: '🏗️',
        title: 'Heavy Equipment Ready',
        desc: 'Equipped with modern tools and machinery to handle projects of any size.',
      },
      {
        icon: '📐',
        title: 'Safety & Accuracy',
        desc: 'Every site is managed with careful planning and strict safety standards.',
      },
    ],
    downHeader: 'Why Choose KU Contractor for Ground Works',
    downSubHeader:
      'We build from the ground up — literally. KU Contractor delivers strong foundations and reliable groundwork for long-term structural stability.',
  },
  {
    mainHeader: 'Kitchen Fittings by KU Contractor',
    mainSubHeader:
      'KU Contractors Limited delivers stylish, practical, and expertly installed kitchen fittings. From layout planning to cabinetry, tiling, and appliances — we create spaces that blend beauty and function.',
    subservices: [
      {
        icon: '/kitcheninstallation.jpg',
        title: 'Full Kitchen Installation',
        desc: 'Complete kitchen setup including cabinets, countertops, and fixtures.',
      },
      {
        icon: '/kitchendesign.jpg',
        title: 'Custom Design & Layout',
        desc: 'Tailored designs that maximize space and suit your style perfectly.',
      },
      {
        icon: '/kitchenplumbing.avif',
        title: 'Plumbing & Electrical Setup',
        desc: 'Safe, efficient connections for sinks, cookers, and appliances.',
      },
      {
        icon: '/kitchentiling.jpeg',
        title: 'Kitchen Tiling & Finishing',
        desc: 'Stylish wall and floor tiling that enhances the look and feel of your kitchen.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🍽️',
        title: 'Functional Design',
        desc: 'We focus on practicality, flow, and style in every kitchen we fit.',
      },
      {
        icon: '🛠️',
        title: 'Expert Installation',
        desc: 'Our team ensures precise fitting and perfect alignment for all units.',
      },
      {
        icon: '🏠',
        title: 'End-to-End Service',
        desc: 'From planning to completion, we handle every detail seamlessly.',
      },
    ],
    downHeader: 'Why Choose KU Contractor for Kitchen Fittings',
    downSubHeader:
      'Your kitchen deserves the perfect balance of style and usability. KU Contractor transforms your vision into a practical and elegant cooking space.',
  },
  {
    mainHeader: 'Electrical Works by KU Contractor',
    mainSubHeader:
      'KU Contractors Limited provides safe, certified, and reliable electrical services for domestic and commercial projects. From rewiring to lighting installations, we handle it all with precision.',
    subservices: [
      {
        icon: '/electricalinstallation.jpg',
        title: 'Full Electrical Installation',
        desc: 'Complete wiring and power setup for new builds, extensions, and refurbishments.',
      },
      {
        icon: '/lighting.jpeg',
        title: 'Lighting Design & Installation',
        desc: 'Indoor and outdoor lighting systems installed to elevate functionality and ambiance.',
      },
      {
        icon: '/fusebox.jpg',
        title: 'Fuse Box & Safety Systems',
        desc: 'Fuse board upgrades, safety checks, and electrical testing for compliance.',
      },
      {
        icon: '/maintenanceelectrical.jpg',
        title: 'Maintenance & Repairs',
        desc: 'Quick and reliable electrical troubleshooting and maintenance services.',
      },
    ],
    whyChooseUs: [
      {
        icon: '⚡',
        title: 'Certified Electricians',
        desc: 'Our qualified team ensures all electrical work meets UK safety standards.',
      },
      {
        icon: '💡',
        title: 'Energy-Efficient Solutions',
        desc: 'We design modern systems that save energy and improve reliability.',
      },
      {
        icon: '🧰',
        title: 'Full-Service Expertise',
        desc: 'From minor repairs to complex wiring projects — we do it all.',
      },
    ],
    downHeader: 'Why Choose KU Contractor for Electrical Works',
    downSubHeader:
      'Safety, precision, and quality define our electrical work. KU Contractor guarantees installations that meet the highest standards of performance and reliability.',
  },
  {
    mainHeader: 'Flat Refurbishment by KU Contractor',
    mainSubHeader:
      'KU Contractors Limited offers complete refurbishment services for apartments and flats — transforming old spaces into modern, functional, and beautiful homes.',
    subservices: [
      {
        icon: '/interiorrefurbishment.jpeg',
        title: 'Interior Renovation',
        desc: 'Redesign and upgrade interiors with new finishes, fittings, and layouts.',
      },
      {
        icon: '/bathroomupgrade.png',
        title: 'Bathroom & Kitchen Upgrades',
        desc: 'Modern installations for better functionality and aesthetics.',
      },
      {
        icon: '/paintingdecor.jpg',
        title: 'Painting & Decoration',
        desc: 'Fresh paint, wallpaper, and detailing to bring new life to your flat.',
      },
      {
        icon: '/flooringrefurbishment.jpeg',
        title: 'Flooring & Lighting',
        desc: 'New floors and lighting that transform your living space completely.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🏢',
        title: 'End-to-End Refurbishment',
        desc: 'We handle every detail — from design to final finish.',
      },
      {
        icon: '🧱',
        title: 'High-Quality Finishes',
        desc: 'Attention to detail ensures a modern, polished, and long-lasting result.',
      },
      {
        icon: '🛋️',
        title: 'Personalized Touch',
        desc: 'We tailor every refurbishment to your taste and lifestyle.',
      },
    ],
    downHeader: 'Why Choose KU Contractor for Flat Refurbishment',
    downSubHeader:
      'Transform tired interiors into vibrant, functional spaces with KU Contractor — your trusted partner for complete flat refurbishments.',
  },
  {
    mainHeader: 'Small Repairs by KU Contractor',
    mainSubHeader:
      'No job is too small for KU Contractors Limited. We handle all types of minor home and office repairs quickly and professionally.',
    subservices: [
      {
        icon: '/wallrepair.avif',
        title: 'Wall & Ceiling Repairs',
        desc: 'Fixing cracks, holes, and surface damage with seamless finishes.',
      },
      {
        icon: '/doorrepair.webp',
        title: 'Door & Window Repairs',
        desc: 'Repairing hinges, locks, seals, and handles for smooth operation.',
      },
      {
        icon: '/plumbingfix.png',
        title: 'Plumbing & Leak Fixes',
        desc: 'Quick fixes for taps, leaks, or drainage issues — handled efficiently.',
      },
      {
        icon: '/painttouchup.webp',
        title: 'Painting Touch-Ups',
        desc: 'Refreshing walls, trims, and corners for a clean, polished appearance.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🔧',
        title: 'Quick Response',
        desc: 'We handle small issues promptly to prevent bigger problems later.',
      },
      {
        icon: '🧰',
        title: 'Skilled Handymen',
        desc: 'Experienced professionals ready to fix any small repair at your property.',
      },
      {
        icon: '💼',
        title: 'Affordable Rates',
        desc: 'Reliable services at transparent and fair pricing.',
      },
    ],
    downHeader: 'Why Choose KU Contractor for Small Repairs',
    downSubHeader:
      'Fast, reliable, and affordable repair services — KU Contractor keeps your property in top shape with minimal disruption.',
  },
  {
    mainHeader: 'Building Maintenance by KU Contractor',
    mainSubHeader:
      'KU Contractors Limited offers ongoing building maintenance for residential and commercial properties, ensuring safety, efficiency, and long-term value.',
    subservices: [
      {
        icon: '/propertyinspection.jpg',
        title: 'Property Inspections',
        desc: 'Routine checks to identify and fix potential issues before they escalate.',
      },
      {
        icon: '/preventativemaintenance.jpg',
        title: 'Preventative Maintenance',
        desc: 'Scheduled upkeep to extend the lifespan of your property assets.',
      },
      {
        icon: '/repairworks.jpg',
        title: 'Repair & Replacement Works',
        desc: 'Comprehensive repairs for structural, plumbing, and electrical systems.',
      },
      {
        icon: '/facilitymanagement.webp',
        title: 'Facility Management',
        desc: 'Professional management for commercial and residential buildings.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🏗️',
        title: 'Comprehensive Care',
        desc: 'We handle every aspect of property maintenance with consistency and care.',
      },
      {
        icon: '🧾',
        title: 'Scheduled Service Plans',
        desc: 'Flexible maintenance schedules tailored to your property’s needs.',
      },
      {
        icon: '🔒',
        title: 'Reliable Support',
        desc: 'Our team is always ready to maintain, repair, and protect your building assets.',
      },
    ],
    downHeader: 'Why Choose KU Contractor for Building Maintenance',
    downSubHeader:
      'With KU Contractor, your property is always in safe hands. We provide dependable maintenance services to keep your buildings efficient and secure.',
  },
  {
    mainHeader: 'Landscaping Services by KU Contractor',
    mainSubHeader:
      'KU Contractors Limited offers complete landscaping solutions for residential and commercial properties. From lush gardens and lawns to paving, fencing, and outdoor lighting, we create outdoor spaces that inspire and endure.',
    subservices: [
      {
        icon: '/gardendesign.webp',
        title: 'Garden Design & Planting',
        desc: 'Expertly planned gardens featuring vibrant plants, shrubs, and trees that enhance your outdoor living space.',
      },
      {
        icon: '/lawns.webp',
        title: 'Lawn Installation & Maintenance',
        desc: 'Professional turfing, seeding, and regular maintenance for healthy, long-lasting lawns.',
      },
      {
        icon: '/paving.webp',
        title: 'Patios & Paving',
        desc: 'Durable and stylish patios, driveways, and pathways built with precision and quality materials.',
      },
      {
        icon: '/outdoorlighting.avif',
        title: 'Fencing & Outdoor Lighting',
        desc: 'Custom fencing and ambient lighting solutions that provide privacy, safety, and elegance.',
      },
    ],
    whyChooseUs: [
      {
        icon: '🌿',
        title: 'Creative Landscape Design',
        desc: 'We craft unique outdoor layouts that combine beauty, practicality, and sustainability.',
      },
      {
        icon: '🪴',
        title: 'High-Quality Materials',
        desc: 'We use premium plants, stones, and fixtures to ensure long-lasting results.',
      },
      {
        icon: '🌞',
        title: 'Expert Installation & Care',
        desc: 'Our skilled landscapers ensure every project is executed with precision and attention to detail.',
      },
    ],
    downHeader: 'Why Choose KU Contractor for Landscaping',
    downSubHeader:
      'With a passion for outdoor design and craftsmanship, our landscaping team transforms ordinary spaces into beautiful, functional environments that elevate your property’s appeal.',
  },
];
